import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SportsTitleCasePipe } from "@sports-pipes/index";

@Component({
  selector: "sb-live-scoreboard-regular",
  templateUrl: "./sb-live-scoreboard-regular.html",
  styleUrls: ["./sb-live-scoreboard-regular.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, SportsTitleCasePipe],
})
export class SbLiveScoreboardRegularComponent {
  @Input() match: any;
  matchTime: string;
  matchPeriod: string;

  ngOnChanges() {
    this.setPeriod();
    this.setTime();
  }

  private setPeriod() {
    if (this.hasNoPeriod(this.match.SportHandle)) {
      return;
    }
    this.matchPeriod = this.match.PeriodName;
  }

  private setTime() {
    if (this.match.RemainingPeriodTime) {
      this.matchTime = this.match.PeriodName === "Descanso" ? "" : "< " + this.match.RemainingPeriodTime;
      return;
    }

    if (this.match.MatchTime) {
      this.matchTime =
        this.match.MatchTime === -1 || this.match.PeriodName === "Descanso" ? "" : this.match.MatchTime + "'";
    }
  }

  hasNoPeriod(sportHandle) {
    if (!sportHandle) {
      return;
    }
    const hasNoPeriod = ["esports"];
    return hasNoPeriod.indexOf(sportHandle.toLowerCase()) !== -1;
  }

  setLegs(index: number): number {
    const num = this.match.Legs.reduce((acc, el) => (acc += el[index]), 0);
    return num;
  }
}
